import { render, staticRenderFns } from "./ExpertiseIncluded.vue?vue&type=template&id=34ab3ad0&scoped=true&lang=pug&"
import script from "./ExpertiseIncluded.vue?vue&type=script&lang=js&"
export * from "./ExpertiseIncluded.vue?vue&type=script&lang=js&"
import style0 from "./ExpertiseIncluded.vue?vue&type=style&index=0&id=34ab3ad0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab3ad0",
  null
  
)

export default component.exports